import * as Api from '@ViewModels';
import { createContentStateWithHtmlStringValue } from '../../../models/utils/richContentUtils';
import { PostContentType } from './types';

export const buildDraftContext = (postContent: string, postContentType: PostContentType): Api.AIContext => {
	const content = createContentStateWithHtmlStringValue(postContent).getRawRichTextContent();
	switch (postContentType) {
		case 'email':
			return { _type: 'EmailAIContext', body: content } as Api.EmailAIContext;
		case 'blog':
			return { _type: 'BlogImageAIContext', content } as Api.BlogImageAIContext;
		default:
			return { _type: 'SocialMediaAIContext', content } as Api.SocialMediaAIContext;
	}
};
